module.exports = __webpack_public_path__ + "static/img/1959_MCRichards_ArtaudLecture_16.d21a40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_MCRichards_ArtaudLecture_16.jpg
// module id = p7N5
// module chunks = 0